
import { TRUCK_MENU_ITEM, TRUCKS_SETTINGS } from "@/consts";
import InventorySummaryTable from "@/components/barcodeSystem/inventory/InventorySummaryTable.vue";
import InventorySummaryFilters from "@/components/barcodeSystem/inventory/InventorySummaryFilters.vue";
import TrucksActions from "@/components/truck/TrucksActions.vue";
import Vue from "vue";
import { getModule } from "vuex-module-decorators";
import InventoryModule from "@/store/modules/barcodeSystem/inventory";
import Component from "vue-class-component";

const inventoryModuleState = getModule(InventoryModule);

@Component({
  components: {
    InventorySummaryTable,
    TrucksActions,
    InventorySummaryFilters
  }
})
export default class InventorySummary extends Vue {
  showInventorySummaryFieldFilter: boolean = false;

  get inventorySummaryFields() {
    return inventoryModuleState.summaryFields;
  }

  async created() {
  }
  async loadMoreSummaryItems() {
    await inventoryModuleState.setLoading(true);
    await inventoryModuleState.getInventorySummary(null);
    await inventoryModuleState.setLoading(false);
  }

  async onSort(s) {
    await inventoryModuleState.setLoading(true);
    await inventoryModuleState.applySummaryListSort(s);
    await inventoryModuleState.setLoading(false);
  }

  toggleChangeTruckField(idx, hideShow) {
    inventoryModuleState.toggleSummaryField({ idx: idx, value: !hideShow });
  }

  get menuItemsToDisplay() {
    return null;
  }

  get dataRetreived() {
    if(inventoryModuleState.summaryData)
      return true;
    return false;
  }
}


